import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const AssetCard = ({ asset, isSelected, onSelect, onPreview, onAction }) => {
  const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes?.[i];
  };

  const getFileIcon = (type) => {
    const iconMap = {
      image: 'Image',
      video: 'Video',
      document: 'FileText',
      icon: 'Sparkles'
    };
    return iconMap?.[type] || 'File';
  };

  const getFileTypeColor = (type) => {
    const colorMap = {
      image: 'bg-primary/10 text-primary',
      video: 'bg-accent/10 text-accent',
      document: 'bg-secondary/10 text-secondary',
      icon: 'bg-success/10 text-success'
    };
    return colorMap?.[type] || 'bg-muted text-muted-foreground';
  };

  return (
    <div
      className={`group relative bg-card border rounded-lg overflow-hidden transition-all duration-250 hover:shadow-md ${
        isSelected ? 'border-primary ring-2 ring-primary/20' : 'border-border'
      }`}
    >
      <div className="absolute top-2 left-2 z-10">
        <button
          onClick={(e) => {
            e?.stopPropagation();
            onSelect(asset?.id);
          }}
          className={`w-6 h-6 rounded border-2 flex items-center justify-center transition-all duration-250 ${
            isSelected
              ? 'bg-primary border-primary' :'bg-background border-border hover:border-primary'
          }`}
          aria-label={isSelected ? 'Deselect asset' : 'Select asset'}
        >
          {isSelected && <Icon name="Check" size={14} color="white" />}
        </button>
      </div>
      <div className="absolute top-2 right-2 z-10 opacity-0 group-hover:opacity-100 transition-opacity duration-250">
        <button
          onClick={(e) => {
            e?.stopPropagation();
            onAction(asset?.id);
          }}
          className="w-8 h-8 bg-background/90 backdrop-blur-sm rounded-lg flex items-center justify-center hover:bg-background transition-all duration-250"
          aria-label="Asset actions"
        >
          <Icon name="MoreVertical" size={16} className="text-foreground" />
        </button>
      </div>
      <div
        onClick={() => onPreview(asset)}
        className="cursor-pointer"
      >
        <div className="aspect-square bg-muted flex items-center justify-center overflow-hidden">
          {asset?.type === 'image' ? (
            <Image
              src={asset?.thumbnail}
              alt={asset?.thumbnailAlt}
              className="w-full h-full object-cover"
            />
          ) : (
            <div className="flex flex-col items-center justify-center gap-2">
              <Icon name={getFileIcon(asset?.type)} size={48} className="text-muted-foreground" />
              <span className="text-xs text-muted-foreground font-medium uppercase">
                {asset?.format}
              </span>
            </div>
          )}
        </div>

        <div className="p-3 space-y-2">
          <div className="flex items-start justify-between gap-2">
            <h3 className="caption font-medium text-foreground line-clamp-1 flex-1">
              {asset?.name}
            </h3>
            <span className={`px-2 py-0.5 rounded text-xs font-medium flex-shrink-0 ${getFileTypeColor(asset?.type)}`}>
              {asset?.format}
            </span>
          </div>

          <div className="flex items-center justify-between text-xs text-muted-foreground">
            <span>{formatFileSize(asset?.size)}</span>
            <span>{asset?.uploadDate}</span>
          </div>

          {asset?.tags && asset?.tags?.length > 0 && (
            <div className="flex flex-wrap gap-1">
              {asset?.tags?.slice(0, 2)?.map((tag, index) => (
                <span
                  key={index}
                  className="px-2 py-0.5 bg-muted rounded text-xs text-muted-foreground"
                >
                  {tag}
                </span>
              ))}
              {asset?.tags?.length > 2 && (
                <span className="px-2 py-0.5 bg-muted rounded text-xs text-muted-foreground">
                  +{asset?.tags?.length - 2}
                </span>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AssetCard;